// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/booking/booking_hold_info.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_core_money } from "../core/money_pb";

/**
 * Describes the file proto/model/booking/booking_hold_info.proto.
 */
export const file_proto_model_booking_booking_hold_info = /*@__PURE__*/
  fileDesc("Citwcm90by9tb2RlbC9ib29raW5nL2Jvb2tpbmdfaG9sZF9pbmZvLnByb3RvEgZjYXJtZW4iyQIKD0Jvb2tpbmdIb2xkSW5mbxIPCgdob2xkX2lkGAEgASgJEisKB2V4cGlyZXMYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEiIKC2hvbGRfYW1vdW50GAMgASgLMg0uY2FybWVuLk1vbmV5EikKBnN0YXR1cxgEIAEoDjIZLmNhcm1lbi5Cb29raW5nSG9sZFN0YXR1cxIfChdwcm92aWRlcl9ob2xkX3JlZmVyZW5jZRgFIAEoCRIrCgdjcmVhdGVkGAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBI1ChJyZXF1ZXN0ZWRfZHVyYXRpb24YByABKAsyGS5nb29nbGUucHJvdG9idWYuRHVyYXRpb24SJAoccGF5bWVudF9jb29yZGluYXRpb25fZW5hYmxlZBgIIAEoCCq+AQoRQm9va2luZ0hvbGRTdGF0dXMSIwofQk9PS0lOR19IT0xEX1NUQVRVU19VTlNQRUNJRklFRBAAEh4KGkJPT0tJTkdfSE9MRF9TVEFUVVNfQUNUSVZFEAESHwobQk9PS0lOR19IT0xEX1NUQVRVU19FWFBJUkVEEAISIAocQk9PS0lOR19IT0xEX1NUQVRVU19SRUxFQVNFRBADEiEKHUJPT0tJTkdfSE9MRF9TVEFUVVNfQ09OVkVSVEVEEARCMFouZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWwvYm9va2luZ2IGcHJvdG8z", [file_google_protobuf_duration, file_google_protobuf_timestamp, file_proto_model_core_money]);

/**
 * Describes the message carmen.BookingHoldInfo.
 * Use `create(BookingHoldInfoSchema)` to create a new message.
 */
export const BookingHoldInfoSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_booking_hold_info, 0);

/**
 * Describes the enum carmen.BookingHoldStatus.
 */
export const BookingHoldStatusSchema = /*@__PURE__*/
  enumDesc(file_proto_model_booking_booking_hold_info, 0);

/**
 * Status of booking holds for state tracking
 *
 * @generated from enum carmen.BookingHoldStatus
 */
export const BookingHoldStatus = /*@__PURE__*/
  tsEnum(BookingHoldStatusSchema);

